import React,{useState} from 'react';
import Footer from '../components/Footer';
import LuxRoomPage from '../components/LuxRoom';
import MaharajaSuite from '../components/MaharajaSuite';

import Navbar from '../components/Navbar';

import Sidebar from '../components/Sidebar';


function MaharajaSuitePage() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />  
            <MaharajaSuite />
           <Footer />
        </div>
    )
}

export default MaharajaSuitePage
